import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = '/api';
const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c', GREEN = '#22a06b';

export default function AppBookings() {
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const phone = localStorage.getItem('userPhone') || '';
        if (phone) {
          const r = await axios.get(`${API}/bookings/customer/${phone}`, { timeout: 12000 });
          setBookings(Array.isArray(r.data) ? r.data : []);
        }
      } catch (e) { setBookings([]); }
      setLoading(false);
    };
    load();
  }, []);

  const statusStyle = (st) => {
    const s = (st || 'pending').toLowerCase();
    if (s === 'confirmed' || s === 'accepted') return { bg: '#dcfce7', c: GREEN, t: 'Confirmed' };
    if (s === 'rejected' || s === 'cancelled') return { bg: '#fee2e2', c: '#dc2626', t: s === 'rejected' ? 'Rejected' : 'Cancelled' };
    if (s === 'completed') return { bg: '#e0e7ff', c: '#4338ca', t: 'Completed' };
    return { bg: '#fef3c7', c: '#b45309', t: 'Pending' };
  };

  const waLink = (b) => {
    const p = String(b.salon_phone || '').replace(/\D/g, '');
    const num = p.length === 10 ? `91${p}` : p;
    const txt = encodeURIComponent(`Namaste! Meri booking ke baare me — ${b.salon_name || ''}, ${b.booking_date || ''} ${b.slot_time || ''}`);
    return num ? `https://wa.me/${num}?text=${txt}` : '';
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fb', maxWidth: 480, margin: '0 auto', paddingBottom: 80 }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '26px 16px 22px' }}>
        <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-0.02em' }}>My Bookings</div>
        <div style={{ fontSize: 13, opacity: 0.85, marginTop: 4 }}>Aapki saari appointments yahan</div>
      </div>

      <div style={{ padding: 16 }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: GREY }}>Loading...</div>
        ) : bookings.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 50, color: GREY }}>
            <div style={{ fontSize: 50 }}>📅</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: INK, marginTop: 12 }}>Abhi koi booking nahi</div>
            <div style={{ fontSize: 13, marginTop: 6 }}>Salon book karें, yahan dikhega.</div>
            <button onClick={() => navigate('/app/home')} style={{ marginTop: 20, background: RED, color: '#fff', border: 'none', borderRadius: 12, padding: '12px 28px', fontWeight: 700, cursor: 'pointer' }}>Salon dhoondhें</button>
          </div>
        ) : (
          bookings.map((b, i) => {
            const st = statusStyle(b.status);
            const wa = waLink(b);
            return (
              <div key={i} style={{ background: '#fff', borderRadius: 16, padding: 16, marginBottom: 12, boxShadow: '0 3px 12px rgba(28,28,40,.06)' }}>
                <div style={{ display: 'flex', gap: 12 }}>
                  <div style={{ width: 56, height: 56, borderRadius: 12, background: 'linear-gradient(135deg,#e2c4b8,#c99d8a)', flexShrink: 0 }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: INK }}>{b.salon_name || 'Salon'}</div>
                    <div style={{ fontSize: 12, color: GREY, marginTop: 2 }}>
                      {Array.isArray(b.services) ? b.services.map(s => s.name || s).join(', ') : (b.service_name || 'Service')}
                    </div>
                    <div style={{ fontSize: 12, color: INK, marginTop: 6, fontWeight: 600 }}>📅 {b.booking_date} · {b.slot_time} {b.total_amount ? `· ₹${b.total_amount}` : ''}</div>
                  </div>
                  <span style={{ fontSize: 10, fontWeight: 800, padding: '4px 10px', borderRadius: 20, background: st.bg, color: st.c, height: 'fit-content' }}>{st.t}</span>
                </div>
                {wa && (
                  <div style={{ display: 'flex', gap: 10, marginTop: 12, borderTop: '1px solid #f0f0f4', paddingTop: 12 }}>
                    <button onClick={() => window.open(wa, '_blank')} style={{ flex: 1, borderRadius: 9, padding: 10, fontSize: 12, fontWeight: 700, border: 'none', background: GREEN, color: '#fff', cursor: 'pointer' }}>📱 WhatsApp</button>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>

      {/* bottom tabs */}
      <div style={{ position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: 480, height: 68, background: '#fff', borderTop: '1px solid #f0f0f4', display: 'flex', zIndex: 30 }}>
        {[['🏠', 'Home', '/app/home'], ['🔍', 'Search', '/app/search'], ['📅', 'Bookings', '/app/bookings'], ['👤', 'Account', '/app/profile']].map(([ic, lbl, path], i) => (
          <div key={i} onClick={() => navigate(path)} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3, fontSize: 10, color: lbl === 'Bookings' ? RED : GREY, cursor: 'pointer', fontWeight: 600 }}>
            <span style={{ fontSize: 21 }}>{ic}</span>{lbl}
          </div>
        ))}
      </div>
    </div>
  );
}
